/**
 * 时间日期相关操作
 */


/**
 * 时间格式化
 * 将 2018-09-23T11:54:16.000+0000 格式化成 2018/09/23 11:54:16
 * @param datetime 国际化日期格式
 */
export function format (datetime) {
  return formatWithSeperator(datetime, "-", ":");
}
export function formatDate (datetime) {
  return formatWithSeperator(datetime, "-");
}

/**
 *
 * 时间格式化
 * 将 2018-09-23T11:54:16.000+0000 格式化成类似 2018/09/23 11:54:16
 * 可以指定日期和时间分隔符
 * @param datetime 国际化日期格式
 */
export function formatWithSeperator (datetime, dateSeprator, timeSeprator) {
  if (datetime != null) {
    const dateMat = new Date(datetime);
    const year = dateMat.getFullYear();
    const month = addZoo(dateMat.getMonth() + 1);
    const day = addZoo(dateMat.getDate());
    var hh = addZoo(dateMat.getHours());
    var mm = addZoo(dateMat.getMinutes());
    var ss = addZoo(dateMat.getSeconds());
    var timeFormat = '';
    if(!timeSeprator){
      if(hh=='00'){
        timeFormat = year + dateSeprator + month + dateSeprator + day;
      }else{
        timeFormat = year + dateSeprator + month + dateSeprator + day + " " + hh + ":" + mm + ":" + ss;
      }
    }else{
      timeFormat = year + dateSeprator + month + dateSeprator + day + " " + hh + timeSeprator + mm + timeSeprator + ss;
    }
    return timeFormat;
  }
}
function addZoo(val) {
  return val < 10 ? 0+""+val : val;

}

/**
 *
 * @param dateNow Date类
 * @param intervalDays 间隔天数
 * @param bolPastTime Boolean,判断在参数date之前，还是之后
 * @returns {*}
 */







// WEBPACK FOOTER //
// ./src/utils/datetime.js